import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface UpdateTransportRequestDonationApiVariables {
  regionId: string
  transportRequestId: string
  donation: { value: number; hasReceipt: boolean }
}

export const useUpdateTransportRequestDonation = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, UpdateTransportRequestDonationApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, UpdateTransportRequestDonationApiVariables>({
    type: 'piloteUpdateTransportRequestDonation',
    ...options,
  })
